import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const rowInputs = [] as const satisfies Inputs;

export type RowProps = PropsWithBuilderChildren<
  BuilderComponentProps<typeof rowInputs>
>;

export const RowComponent: RegisteredComponent = {
  name: "Row",
  component: dynamic(() => import("./Row").then((mod) => mod.Row)),
  inputs: rowInputs,
  canHaveChildren: true,
  childRequirements: {
    message: "Children of 'Row' must be 'Column'",
    query: {
      "component.name": {
        $in: ["Column"],
      },
    },
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Column",
        options: {
          desktopWidth: "6",
        },
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Column",
        options: {
          desktopWidth: "6",
        },
      },
    },
  ],
};
